import { ENV } from './config.js';

/**
 * GrphQL Query to Piers
 */

    function createInputs( token ) {
        return {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                'authorization': `Bearer ${ token }`,
            }
        };
    }
    export async function getProfile( personId, token ) {
        const response = await fetch( `https://${ ENV }api.biw.cloud/v1/piers/profile/${ personId }`, createInputs( token ) );
    
        return await response.json();
    }
    export async function getMarketPlace( personId, token ) {
        const response = await fetch( `https://${ ENV }api.biw.cloud/v1/piers/marketplace/${ personId }`, createInputs( token ) );
    
        return await response.json();
    }
    export async function getCompanies( personId, token ) {
        const response = await fetch( `https://${ ENV }api.biw.cloud/v1/piers/companies/${ personId }`, createInputs( token ) );
    
        return await response.json();
    }
    export async function getSolutions( personId, token ) {
        const response = await fetch( `https://${ ENV }api.biw.cloud/v1/piers/solutions/${ personId }`, createInputs( token ) );
    
        return await response.json();
      }
    export async function getRewards( personId, token ) {
        const response = await fetch( `https://${ ENV }api.biw.cloud/v1/piers/rewards/${ personId }`, createInputs( token ) );
    
        return await response.json();
      }